export const waitForElement = (
  selector: string,
  observedElement = document.documentElement,
  timeout = 2000,
): Promise<Element> =>
  new Promise((resolve, reject) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const nodes = Array.from(mutation.addedNodes);
        for (let i = 0; i < nodes.length; i += 1) {
          const node = nodes[i];
          if (node instanceof Element && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            break;
          }
        }
      });
    });

    setTimeout(() => {
      observer.disconnect();
      reject();
    }, timeout);

    observer.observe(observedElement, { childList: true, subtree: true });
  });
